import React from 'react';
import { ActivationCard } from './ActivationCard';

interface WaitingScreenProps {
  verificationCode: string | null;
  verificationType: string | null;
  timeRemaining: number;
  login?: string;
  onCancel: () => void;
  title?: string;
  subtitle?: string;
  hint?: string;
}

const formatTime = (seconds: number): string => {
  const mins = Math.floor(seconds / 60);
  const secs = seconds % 60;
  return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
};

export const WaitingScreen: React.FC<WaitingScreenProps> = ({
  verificationCode,
  verificationType,
  timeRemaining,
  login,
  onCancel,
  title = 'RFID Activation',
  subtitle = 'Enter this code on your device',
  hint = 'Enter this code on your device screen to complete RFID registration.',
}) => (
  <ActivationCard>
    <>
      <div className="text-center mb-4">
        <h1 className="h3 mb-2 fw-bold">{title}</h1>
        <p className="text-muted">{subtitle}</p>
      </div>

      <div className="text-center mb-4">
        <div
          className="bg-primary text-white p-4 rounded"
          style={{ fontSize: '3rem', fontWeight: 'bold', letterSpacing: '0.25em' }}
        >
          {verificationCode ?? '------'}
        </div>
        {verificationType && (
          <p className="text-muted small mt-2 mb-0">
            Type: <strong>{verificationType}</strong>
          </p>
        )}
      </div>

      <div className="text-center mb-4">
        <div className="mb-1 text-muted">
          <i className="fas fa-clock me-2"></i>Time remaining:
        </div>
        <div
          className={`h2 mb-0 ${timeRemaining <= 10 ? 'text-danger' : 'text-primary'}`}
          style={{ fontFamily: 'monospace' }}
        >
          {formatTime(timeRemaining)}
        </div>
      </div>

      <div className="alert alert-info" role="alert">
        <i className="fas fa-info-circle me-2"></i>
        {hint}
      </div>

      {login && (
        <p className="text-muted small mb-3">
          Signed in as: <strong>{login}</strong>
        </p>
      )}

      <button onClick={onCancel} className="btn btn-outline-secondary w-100">
        <i className="fas fa-times me-2"></i>
        Cancel
      </button>
    </>
  </ActivationCard>
);
